import axios from 'axios';

const axiosInstance = axios.create({
  timeout: 20000,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token') || '';
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers['X-Access-Token'] = token;
  }
  return config;
}, (err) => Promise.reject(err));

export default axiosInstance;
